module.exports = __webpack_public_path__ + "static/img/qizhijia2.eb4d1d1e.png";